import { ServiceComponents } from 'src/app/components/service/serviceComponents.service';
import { PersonaNatural } from 'src/app/models/persona-natural';
import { isNullOrUndefined } from 'util';
import { PerfilService } from 'src/app/services/perfil.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Component, OnInit, HostListener, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, NavigationStart } from '@angular/router';
import { DataService } from 'src/app/shared/services/data.service';
import { RedSocial } from 'src/app/models/red-social';
import { GeneralService } from 'src/app/services/general.service';
import { Unidad } from 'src/app/models/unidad';
import { decode } from 'punycode';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { DatePipe } from '@angular/common';
import { Subscription } from 'rxjs';
import { Rutas } from 'src/app/models/rutas';


@Component({
    selector: 'app-header-enjoy-cl',
    templateUrl: './header-enjoy-cl.component.html',
    styleUrls: ['./header-enjoy-cl.component.scss']
})
export class HeaderEnjoyClComponent implements OnInit {

    private personaNatural: PersonaNatural = new PersonaNatural();
    activeLang = 'es';
    changeText: boolean;
    unidadesFirst: any;
    image: string;
    idioma = '';
    rutaEnjoyClub: Rutas;
    rutaEnjoySerie: Rutas;
    rutaEnjoyWin: Rutas;
    subscription: Subscription;
    
    innerWidth: any;
    topMobile = false;

    varNombre = '';

    unidadSelected: Unidad;

    redesSociales: RedSocial[];

    url: string = '';

    constructor(
        public authService: AuthenticationService,
        private translate: TranslateService,
        private router: Router,
        private dataService: DataService,
        private serviceComponent: ServiceComponents,
        private perfilService: PerfilService,
        private datePipe: DatePipe,
        @Inject(PLATFORM_ID) public platformId: Object,
        private generalService: GeneralService) {
        if (isPlatformBrowser(this.platformId)) {
            this.translate.setDefaultLang(this.activeLang);
        }
        this.changeText = false;
    }

    ngOnInit() {
        this.getLink();
    }

    async getLink() {
            this.subscription = this.dataService.$idioma.subscribe(value => {
                this.idioma = value;
            });
            this.dataService.currentUnidades.subscribe(unidades => {
                this.unidadesFirst = unidades;
                if (this.unidadesFirst[0]) {
                    this.image = this.unidadesFirst[0].pathImagen;
                }

            });
    
            this.dataService.currentUnidadSelected.subscribe(unidadSelected => {
                this.unidadSelected = unidadSelected;
                this.getRedesSociales();
            });
    
            this.innerWidth = window.innerWidth;
            if (this.innerWidth <= 1024 && this.topMobile == false) {
                this.topMobile = true;
            } else if (this.innerWidth > 1024 && this.topMobile == true) {
                this.topMobile = false;
            }
    
            this.personaNatural = this.perfilService.obtenerUsuarioVerificado();
    
            this.getDataCliente();
            const RUTAS = await this.serviceComponent.getLinks()
            .then(resRuta => {
                if (resRuta['codigo'] === 1) {
                    const RUTACLUB = resRuta['data'];
                    this.rutaEnjoyClub = new Rutas(RUTACLUB[1]);
                    this.rutaEnjoySerie = new Rutas(RUTACLUB[2]);
                    this.rutaEnjoyWin = new Rutas(RUTACLUB[6]);
                }
            });

    }
    private cleanData() {
        this.varNombre = '';
    }

    getDataCliente() {
        this.perfilService.dataCliente$.subscribe(data => {
            if (isNullOrUndefined(data) || data.length === 0) {
                this.cleanData();
            } else {
                this.varNombre = data.nombre;
            }
        });

        // en el caso de llegar a actualizar la pagina, este llamado permitirá actualizar la data del cliente
        if (this.personaNatural.idUsuario > 0 && this.personaNatural.idUnidad >= 0) {
            this.serviceComponent.getClientes(this.personaNatural.idUsuario, this.personaNatural.idUnidad, 0)
                .subscribe(response => {
                    // do nothing
                });
        }
    }

    getRedesSociales(home: boolean = false) {
        let unidadConsulta = 0
        if (this.unidadSelected.idUnidad == undefined || home) {
            unidadConsulta = 0
        } else {
            unidadConsulta = this.unidadSelected.idUnidad
        }

        this.generalService.redesSociales(unidadConsulta).subscribe(result => {
            if (result['codigo'] === 1) {
                this.redesSociales = result['data'].filter((red:RedSocial) =>red.link!="" );
            }
        });
    }

    setLanguage(lang) {
        this.activeLang = lang;
        if (isPlatformBrowser(this.platformId)) {
            this.translate.use(lang);
            this.dataService.setIdioma(lang);
        }
    }

    toNavigate(route) {
        this.router.navigate([route]);
    }

    onMouseEnter(event) {
        if (isPlatformBrowser(this.platformId)) {
            document.getElementById('div1').style.display = 'block';
        }
    }

    onMouseLeave(event) {
        if (isPlatformBrowser(this.platformId)) {
            document.getElementById('div1').style.display = 'none';
        }
    }

    closeHover() {
        if (isPlatformBrowser(this.platformId)) {
            document.getElementById('div1').style.display = 'none';
        }

    }

    linkReserva()
    {
        var _url = this.router.url;
        if (_url.indexOf("antofagasta") > 0 || _url.indexOf("coquimbo") > 0 || _url.indexOf("puc") > 0 || _url.indexOf("vina-del-mar") > 0 || _url.indexOf("chilo") > 0 || _url.indexOf("santiago") > 0 || _url.indexOf("san-antonio") > 0 || _url.indexOf("punta-del-este") > 0)
        {
            var canal = "";
            if (_url.indexOf("antofagasta") > 0) {
                canal = "HDDES";
            }else if (_url.indexOf("coquimbo") > 0){
                canal = "HDBAH";
            }else if(_url.indexOf("puc") > 0){
                canal = "HDPUC";
            }else if(_url.indexOf("vina-del-mar") > 0){
                canal = "HDMAR";
            }else if(_url.indexOf("chilo") > 0){ 
                canal = "HDISL";
            }else if(_url.indexOf("santiago") > 0){
                canal = "HDVAL";
            }else if(_url.indexOf("san-antonio") > 0){
                canal = "HDSAN";
            }else if(_url.indexOf("punta-del-este") > 0)
            {
                canal = "HDPUN";
            }
            
            var fecha = new Date();
            var inicio = this.datePipe.transform(fecha, 'yyyy-MM-dd');
            fecha.setDate(fecha.getDate() + 1);
            var fin = this.datePipe.transform(fecha, 'yyyy-MM-dd');
            var reserva = "disponibilidad/" + canal + "/ES/" + inicio + "/" + fin;
            reserva += "/1/2/0/CLP/PERSONAS";
            //disponibilidad/HDDES/ES/2026-01-23/2026-01-24/1/2/0/CLP/PERSONAS
            
            window.open('https://reservasweb.enjoy.cl/' + reserva);
        }
        else
            {
            window.open('https://reservasweb.enjoy.cl');
        }
    }

    onMouseEnterUnidad(unidad) {
        this.image = unidad.pathImagen;
    }

    showUnidad(unidad) {
        if (isPlatformBrowser(this.platformId)) {
            this.dataService.changeUnidadSelected(unidad);
            this.router.navigate([`/${unidad.nombre.replace(/[' ']+/g, '-').replace(/['ñ']+/g, 'n').toLowerCase()}`]);
            document.getElementById('div1').style.display = 'none';
        }

    }

    showHome() {
        this.getRedesSociales(true);
        this.router.navigate(['/home']);
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.innerWidth = window.innerWidth;
        if (this.innerWidth <= 1024 && this.topMobile == false) {
            this.topMobile = true;
        } else if (this.innerWidth > 1024 && this.topMobile == true) {
            this.topMobile = false;
        }
    }

    @HostListener('window:popstate', ['$event'])
    onPopState(event) {
        this.changenavegacion()
    }

    changenavegacion() {
        this.router.events.subscribe(e => {
            if (e instanceof NavigationStart) {
                this.generalService.changeUrl(e.url);
                this.buscarUnidadByNombre(e.url)
            }
        });
    }

    buscarUnidadByNombre(url: string) {

        if (url == '/home') {
            this.getRedesSociales(true)
        } else {
            url = decodeURI(url)
            for (let i = 0; i < this.unidadesFirst.length; i++) {
                let unidad = this.unidadesFirst[i];
                let nameUnidad = '/' + unidad.nombre.replace(/[' ']+/g, '-').replace(/['ñ']+/g, 'n').toLowerCase()
                if (nameUnidad == url) {
                    this.unidadSelected = unidad
                    break
                }
            }

            this.getRedesSociales(false)
        }

    }


}
